// services/PublicOrderingServices.js
// import _BaseAPIService from "../_BaseAPIService";

import axios from "axios";
import _BaseAPIService from "../../../services/_BaseAPIService";

const apiService = _BaseAPIService.instance;
_BaseAPIService.instance = axios.create({
  baseURL: window.APP_CONFIG.api1.baseapi,
});

const baseURL = window.APP_CONFIG.api1.baseapi;

const PublicOrderingServices = {
  registerCustomer: async (payload) => {
    const response = await _BaseAPIService.instance.post(
      `/customerauth/register-customer`,
      payload,
    );
    return response.data;
  },

  registerCustomerPhoneNumber: async (phoneNumber) => {
    const response = await _BaseAPIService.instance.post(
      `/customerauth/register-phoneno?` + new URLSearchParams({ phoneNumber }),
      {},
    );
    return response?.data;
  },

  customerLogin: async (payload) => {
    const response = await _BaseAPIService.instance.post(
      "/customerauth/customer-login",
      payload,
    );
    return response?.data;
  },

  customerPhoneLogin: async (phoneNumber) => {
    const response = await _BaseAPIService.instance.post(
      `/customerauth/register-phoneno?` + new URLSearchParams({ phoneNumber }),
      {},
    );
    return response?.data;
  },

  customerAuthForgotPassword: async ({ emailAddress }) => {
    const response = await _BaseAPIService.instance.post(
      "/customerauth/forgot-password",
      {
        emailAddress,
      },
    );
    return response?.data;
  },

  customerAuthResetPassword: async ({
    emailAddress,
    password,
    confirmPassword,
    otp,
  }) => {
    const response = await _BaseAPIService.instance.post(
      "/customerauth/reset-password",
      {
        emailAddress,
        password,
        confirmPassword,
        otp,
      },
    );
    return response?.data;
  },

  verifyOtp: async ({ email, otp, isPhoneNumber = false }) => {
    const response = await _BaseAPIService.instance.post(
      "/customerauth/verify-otp",
      {
        email,
        otp,
        isPhoneNumber,
      },
    );
    return response?.data;
  },

  // ======================= ORDER ONLINE ==========================
  orderOnline: async ({ token, apikey, orderPayload, phoneNumber }) => {
    try {
      const params = phoneNumber ? new URLSearchParams({ phoneNumber }) : null;
      const url = phoneNumber ? `/orderonline?${params}` : `/orderonline`;

      const response = await _BaseAPIService.instance.post(url, orderPayload, {
        headers: {
          APIKEY: apikey,
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Order Online Error:", error);
      throw error?.response?.data || error;
    }
  },

  // ======================= GET CUSTOMER ONGOING ORDERS ==========================
  getCustomerOngoingOrders: async ({ token, apikey }) => {
    try {
      const response = await _BaseAPIService.instance.get(
        `/orderonline/customer-ongoing`,
        {
          headers: {
            APIKEY: apikey,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Get Customer Ongoing Orders Error:", error);
      throw error?.response?.data || error;
    }
  },

  // ======================= GET CUSTOMER ALL ORDERS ==========================
  getCustomerOrders: async ({
    token,
    apikey,
    pageNumber = 1,
    pageSize = 10,
  }) => {
    console.log("🚀 ~ apikey:", apikey);
    try {
      const response = await _BaseAPIService.instance.get(
        `/orderonline/customer-orders`,
        {
          headers: {
            APIKEY: apikey,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          // params: { pageNumber, pageSize }, // server supports pagination
        },
      );

      return response.data;
    } catch (error) {
      console.error("Get Customer Orders Error:", error);
      throw error?.response?.data || error;
    }
  },

  // ======================= UPDATE ORDER STATUS ==========================
  updateOrderStatus: async ({ orderRefNumber, status, apikey, token }) => {
    try {
      const params = new URLSearchParams({
        ...(orderRefNumber && { orderRefNumber: orderRefNumber.toString() }),
        ...(status && { status: status }),
      });
      const response = await _BaseAPIService.instance.put(
        `/order/update-order-status?${params.toString()}`,
        null, // no body, params are in query
        {
          headers: {
            // APIKEY: apikey,
            Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
            "Content-Type": "application/json",
          },
          // params: {
          //   orderRefNumber,
          //   status,
          // },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Update Order Status Error:", error);
      throw error?.response?.data || error;
    }
  },

  // ======================= UPDATE ORDER STATUS ==========================
  updateCustomerOrderStatus: async ({
    orderRefNumber,
    status,
    apikey,
    token,
  }) => {
    try {
      const params = new URLSearchParams({
        orderRefNumber: orderRefNumber,
        status: status, // must be an integer
      });

      const response = await _BaseAPIService.instance.put(
        `/orderonline/update-order-status?${params.toString()}`,
        null,
        {
          headers: {
            APIKEY: apikey,
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Update Order Status Error:", error);
      throw error?.response?.data || error;
    }
  },

  getCustomerOrderDetail: async ({ token, apikey, orderRefNumber }) => {
    try {
      const response = await _BaseAPIService.instance.get(
        `/orderonline/customer-order-detail/${orderRefNumber}`,
        {
          headers: {
            APIKEY: apikey,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Get Customer Order Detail Error:", error);
      throw error?.response?.data || error;
    }
  },

  markOnlineOrderPaid: async ({
    orderId,
    paymentTypeId,
    amount,
    panNumber = "",
    remarks = "",
    discountAmount = 0,
    discountPercentage = 0,
    apikey,
    // token,
  }) => {
    // console.log("🚀 ~ token:", token);
    console.log("🚀 ~ apikey:", apikey);
    const orderRef = orderId;
    try {
      const response = await _BaseAPIService.instance.post(
        "/orderonline/mark-online-order-paid",
        {
          orderRef,
          paymentTypeId,
          amount,
          panNumber,
          remarks,
          discountAmount,
          discountPercentage,
        },
        {
          headers: {
            APIKEY: apikey,
            // Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Mark Online Order Paid Error:", error);
      throw error?.response?.data || error;
    }
  },

  // ======================= CHANGE PASSWORD ==========================
  changePassword: async ({
    token,
    oldPassword,
    newPassword,
    confirmPassword,
  }) => {
    try {
      const response = await _BaseAPIService.instance.post(
        "/api/auth/change-password",
        {
          oldPassword,
          newPassword,
          confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Change Password Error:", error);
      throw error?.response?.data || error;
    }
  },

  checkNqrtReport: async ({ validationTraceId, merchantId, acquirerId }) => {
    try {
      const response = await _BaseAPIService.instance.post(
        "/nqr/merchant-txn-report",
        {
          validationTraceId,
          merchantId,
          acquirerId,
        },
      );
      return response?.data;
    } catch (error) {
      console.error("Check NQRT Report Error:", error);
      throw error?.response?.data || error;
    }
  },
};

export default PublicOrderingServices;
